import type { RestLicenseChangesResponse } from "@KassaroAB/shared/types/licenseChanges";
import type { ResellerId } from "@KassaroAB/shared/types/ids";
import { api } from "../utils/api";

export const getLicenseChangesApi = async (
  month: string,
  resellerId?: ResellerId
): Promise<RestLicenseChangesResponse> => {
  const params = new URLSearchParams({ month });
  const path = resellerId
    ? `resellers/${resellerId}/stats/license-changes`
    : "admin/stats/license-changes";
  return api.get<RestLicenseChangesResponse>(`${path}?${params.toString()}`);
};
